import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { useToast } from './useToast';

export function useLogout() {
  const logoutStore = useStore((s) => s.logout);
  const navigate = useNavigate();
  const { showToast } = useToast();

  return async () => {
    try {
      await logoutStore();
      showToast('success', 'Logged Out', 'You have been logged out.');
      navigate('/login');
    } catch (error) {
      console.error('Error during logout:', error);
      showToast('error', 'Error', 'Failed to logout properly. Please try again.');
      // Still navigate to login even if there's an error
      navigate('/login');
    }
  };
}
